import {HeroLayoutTypeEnum, PageTypesEnum} from "@/scripts/common/enums.js";

export default {
    portfolioTemplateSettings(state) {
        return state.portfolio.templateSettings
    },
    portfolioHero(state, getters) {
        return getters.portfolioTemplateSettings.hero;
    },
    portfolioUsesRootHeaderSections(state) {
        return !!state.portfolio?.portfolioHero && !!state.portfolio?.portfolioNavigation;
    },
    portfolioHasHeroSection(state) {
        return !!state.portfolio?.portfolioHero;
    },
    portfolioHasNavigationSection(state) {
        const hasNavigation = !!state.portfolio?.portfolioNavigation;
        if (!hasNavigation) return false;

        const isCaseStudy = state.project?.type === PageTypesEnum.CASE_STUDY;
        if (isCaseStudy) {
            return state.portfolio?.portfolioHero?.layoutSettings?.layoutType === HeroLayoutTypeEnum.SIDEBAR
                || !!state.portfolio?.settings?.showNavOnCollectionItems;
        }

        return true;
    },
}